export default __webpack_public_path__ + "static/media/add_icon.58f93b29.svg";